//
// Copyright 2022 DXOS.org
//
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
/**
 * Describes the file dxos/mesh/teleport/automerge.proto.
 */
export const file_dxos_mesh_teleport_automerge = /*@__PURE__*/ fileDesc("CiJkeG9zL21lc2gvdGVsZXBvcnQvYXV0b21lcmdlLnByb3RvEhxkeG9zLm1lc2gudGVsZXBvcnQuYXV0b21lcmdlIhYKCFBlZXJJbmZvEgoKAmlkGAEgASgJIh4KC1N5bmNNZXNzYWdlEg8KB3BheWxvYWQYAiABKAwyxgEKGkF1dG9tZXJnZVJlcGxpY2F0b3JTZXJ2aWNlElIKEFN0YXJ0UmVwbGljYXRpb24SJi5keG9zLm1lc2gudGVsZXBvcnQuYXV0b21lcmdlLlBlZXJJbmZvGhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5ElQKD1NlbmRTeW5jTWVzc2FnZRIpLmR4b3MubWVzaC50ZWxlcG9ydC5hdXRvbWVyZ2UuU3luY01lc3NhZ2UaFi5nb29nbGUucHJvdG9idWYuRW1wdHliBnByb3RvMw", [file_google_protobuf_empty]);
/**
 * Describes the message dxos.mesh.teleport.automerge.PeerInfo.
 * Use `create(PeerInfoSchema)` to create a new message.
 */
export const PeerInfoSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_teleport_automerge, 0);
/**
 * Describes the message dxos.mesh.teleport.automerge.SyncMessage.
 * Use `create(SyncMessageSchema)` to create a new message.
 */
export const SyncMessageSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_teleport_automerge, 1);
/**
 * @generated from service dxos.mesh.teleport.automerge.AutomergeReplicatorService
 */
export const AutomergeReplicatorService = /*@__PURE__*/ serviceDesc(file_dxos_mesh_teleport_automerge, 0);
//# sourceMappingURL=automerge_pb.js.map